import MetricsRibbon from './MetricsRibbon';

export default MetricsRibbon;
